import { IconGoogle24 } from 'src/shared/components/icon-google-24/icon-google-24.js';

import { cnOpenGmailButton } from './open-gmail-button.constants.js';

import './open-gmail-button.css';

type OpenGmailButtonProps = {
    message: string;
};

export const OpenGmailButton = ({ message }: OpenGmailButtonProps) => (
    <a href="https://mail.google.com/" target="_blank" className={cnOpenGmailButton()} rel="noreferrer">
        <IconGoogle24 />
        <span>{message}</span>
    </a>
);
